import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { LoadingIndicator } from "../../components/placeholders";
import { StorageService } from "../../services";

const ProcessPlanPurchase = () => {
  const navigate = useNavigate();
  const { planUUID } = useParams();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const setPlanId = async () => {
      if (planUUID) {
        setLoading(() => true);
        await new Promise((r) => setTimeout(r, 1000));
        await StorageService.setMarketPlansUrl("planUUID", planUUID);
        setLoading(() => false);
      }
      navigate("/itr-filings", { replace: true });
    };

    setPlanId();
  }, []);

  return <>{loading && <LoadingIndicator />}</>;
};

export default ProcessPlanPurchase;
